import { Box, Typography } from "@mui/material"
import { useTranslate, Link } from "react-admin"

const WarningNoTaxInfo = ({userId}: {userId: string}) => {

  const translate = useTranslate()

  return (
    <Box mb={3}>
      <Typography color={"error"}>
        {translate("resources.invoices.dialogs.noTaxWarning")}
      </Typography>
      <Link to={`/users/${userId}/edit`}>Steuernummer oder USt-Id anlegen</Link>
    </Box>
  )
}

export default WarningNoTaxInfo